import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '../pages/_layout/AppLayout';
import ForgotPassword from '../pages/auth/ForgotPassword';
import Login from '../pages/auth/Login';
import Page404 from '../pages/auth/Page404';
import ResetPassword from '../pages/auth/ResetPassword';
import { RootState } from "../redux/store";
import { menuRoutes } from './menu';
import ProtectedRoute from './ProtectedRoute';
import contents from './routes';
import ChangePassword from "../pages/auth/ChangePassword";
import ShowReceipt from "../pages/public/ShowReceipt";

const AppRouter = () => {

  const user = useSelector((state: RootState) => state.auth);

  const renderRoute = (page: any, index: number, access: boolean = true) => {
    if(user.user?.temporalPasswordExpiration !== false) return;
    page.element = <ProtectedRoute component={page.element} access={access && page.access} />;
    return (
      <Route key={index} {...page}>
        {page.sub?.map((subPage: any, index: number) => renderRoute(subPage, index))}
      </Route>
    );
  };

  return (
    <Routes>
      <Route element={<AppLayout />}>
        {contents.map((page, index) => renderRoute(page, index))}
      </Route>

      {/* Ruta pública para previsualizar albarán sin autenticación */}
      <Route path="/show-receipt/:hash" element={<ShowReceipt />} />

      <Route path={menuRoutes.auth.login} element={<Login />} />
      <Route path={menuRoutes.auth.forgot_password} element={<ForgotPassword />} />
      <Route path={menuRoutes.auth.reset_password} element={<ResetPassword />} />
      {user.isAuthenticated && user.user?.temporalPasswordExpiration !== false && <Route path="*" element={<ChangePassword />} />}
      {user.isAuthenticated &&  user.user?.temporalPasswordExpiration === false && <Route path="/" element={<Navigate to={ menuRoutes.dashboard.path} />} />}
      {(!user.isAuthenticated) && <Route path="*" element={<Navigate to={menuRoutes.auth.login} />} />}
      {(user.isAuthenticated) && <Route path="*" element={<Page404 />} />}
    </Routes>
  );
};

export default AppRouter;